export const API_URL =
  process.env.REACT_APP_ENV === 'prod'
    ? 'http://localhost:5000/'
    : process.env.REACT_APP_ENV === 'test'
      ? 'https://hrms-api.apisod.ai/'
      : 'http://127.0.0.1:8000/';
